
define('app/board/views/timerView',[
	'jquery',
	'underscore',
	'backbone',
	'known/models/userModel',
	'known/models/leagueInstanceModel',
	'app/board/models/timerModel',
	'app/board/views/soundView',
], function($, _, Backbone, UserModel, LeagueInstanceModel, TimerModel, SoundView){
	var TimerDurFooterView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			this.leagueInstance = options.leagueInstance;
			
			this.formEl = $(this.el).find(".timerDurBodyContentNormalForm");
			
			if(this.leagueInstance.get('draftType') == 'AUCTION') {
				this.formEl = $(this.el).find(".timerDurBodyContentAuctionForm");
			}
			
			this.listenTo(this.event, 'default', this.showSubmit);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.showSubmit);
			this.listenTo(this.event, 'success', this.showSubmit);
			
			_.bindAll(this, 'submitTimerDur');			
			$(this.formEl).find(".timerDurFormSubmit").on('click', this.submitTimerDur);
		},
		
		hideAll: function () {
			$(this.formEl).find(".timerDurFormSubmit").hide();
		},
		
		submitTimerDur: function () {
			this.event.trigger("save");
		},
		
		showSubmit: function () {
			this.hideAll();
			$(this.formEl).find(".timerDurFormSubmit").show();
		},
		
		destroyView: function () {
			$(this.formEl).find(".timerDurFormSubmit").off('click', this.submitTimerDur);
			this.stopListening();
	    	this.undelegateEvents();
		}
	});

	var TimerDurContentView = Backbone.View.extend({	
		initialize: function(options) {
			this.event = options.event;
			
			this.draftTimer = options.draftTimer;
			this.leagueInstance = options.leagueInstance;
			this.draftStatusModel = options.draftStatusModel;
			
			this.durInitialized = false;
			
			this.formEl = $(this.el).find(".timerDurBodyContentNormalForm");
			
			if(this.leagueInstance.get('draftType') == 'AUCTION') {
				this.formEl = $(this.el).find(".timerDurBodyContentAuctionForm");
			}
			
			this.hideAll();
			this.populateDurationInfo();
			
			this.listenTo(this.event, 'save', this.submitDuration);
			this.listenTo(this.event, 'default', this.form);
			this.listenTo(this.event, 'saving', this.hideAll);
			this.listenTo(this.event, 'error', this.form);
			this.listenTo(this.event, 'success', this.formReset);
			
			this.listenTo(this.draftTimer, 'change', this.populateDurationInfo);
			
			//Error handling
			this.listenTo(this.event, 'error:hours', this.errorHours);
			this.listenTo(this.event, 'error:mins', this.errorMins);
			this.listenTo(this.event, 'error:secs', this.errorSecs);
			this.listenTo(this.event, 'error:nommins', this.errorNomMins);
			this.listenTo(this.event, 'error:nomsecs', this.errorNomSecs);
			this.listenTo(this.event, 'error:bidmins', this.errorBidMins);
			this.listenTo(this.event, 'error:bidsecs', this.errorBidSecs);
			this.listenTo(this.event, 'error:resetmins', this.errorResetMins);
			this.listenTo(this.event, 'error:resetsecs', this.errorResetSecs);
			
			_.bindAll(this, 'submitSuccess');
			_.bindAll(this, 'submitError');
		},
		
		submitDuration: function () {
			this.event.trigger("saving");
			
			var isAuction = this.leagueInstance.get('draftType') == 'AUCTION';
			var isError = false;
			
			var durMille = 0;
			var nomMille = 0;
			var bidMille = 0;
			var resetMille = 0;
			
			
			if(!isAuction){
				var hourInput = $(this.formEl).find(".timerDurTimeInput1").val();
				var minInput = $(this.formEl).find(".timerDurTimeInput2").val();
				var secInput = $(this.formEl).find(".timerDurTimeInput3").val();
				
				var hoursErrCode = this.validateField(hourInput);
				var minsErrCode = this.validateField(minInput);
				var secsErrCode = this.validateField(secInput);
				
				isError = hoursErrCode || minsErrCode || secsErrCode;
				
				if(!isError){
					//Don't allow 99:99:99, cut it down to 99:59:59
					if(hourInput == 99 && minInput > 59){
						minInput = 59;
						secInput = 59;
					} else if(hourInput == 99 && minInput == 59 && secInput > 59) {
						secInput = 59;
					}
					
					//Add a second for latency and to make it "prettier"
					durMille = (hourInput * (1000 * 60 * 60)) + (minInput * (1000 * 60)) + (secInput * 1000) + 999; 
				} else {
					this.event.trigger("error");
					
					if(hoursErrCode){
						this.event.trigger("error:hours", hoursErrCode);
					}
					
					if(minsErrCode){
						this.event.trigger("error:mins", minsErrCode);
					}
					
					if(secsErrCode){
						this.event.trigger("error:secs", secsErrCode);
					}
				}
			} else {
				var nomMinInput = $(this.formEl).find(".nomTimerDurTimeInput1").val();
				var nomSecInput = $(this.formEl).find(".nomTimerDurTimeInput2").val();
				var bidMinInput = $(this.formEl).find(".bidTimerDurTimeInput1").val();
				var bidSecInput = $(this.formEl).find(".bidTimerDurTimeInput2").val();
				var resetMinInput = $(this.formEl).find(".resetTimerDurTimeInput1").val();
				var resetSecInput = $(this.formEl).find(".resetTimerDurTimeInput2").val();
				
				var nomMinsErrCode = this.validateField(nomMinInput);
				var nomSecsErrCode = this.validateField(nomSecInput);
				var bidMinsErrCode = this.validateField(bidMinInput);
				var bidSecsErrCode = this.validateField(bidSecInput);
				var resetMinsErrCode = this.validateField(resetMinInput);
				var resetSecsErrCode = this.validateField(resetSecInput);
				
				isError = nomMinsErrCode || nomSecsErrCode || bidMinsErrCode || bidSecsErrCode || resetMinsErrCode || resetSecsErrCode;
				
				if(!isError){
					//Don't allow 99:99:99, cut it down to 99:59:59
					if(nomMinInput > 59){
						nomMinInput = 59;
						nomSecInput = 59;
					} else if(nomMinInput == 59 && nomSecInput > 59) {
						nomSecInput = 59;
					}
					if(bidMinInput > 59){
						bidMinInput = 59;
						bidSecInput = 59;
					} else if(bidMinInput == 59 && bidSecInput > 59) {
						bidSecInput = 59;
					}
					if(resetMinInput > 59){
						resetMinInput = 59;
						resetSecInput = 59;
					} else if(resetMinInput == 59 && resetSecInput > 59) {
						resetSecInput = 59;
					}
					
					//Add a second for latency and to make it "prettier" 
					nomMille = (nomMinInput * (1000 * 60)) + (nomSecInput * 1000) + 999;
					bidMille = (bidMinInput * (1000 * 60)) + (bidSecInput * 1000) + 999;
					resetMille = (resetMinInput * (1000 * 60)) + (resetSecInput * 1000) + 999;
				} else {
					this.event.trigger("error");
					
					if(nomMinsErrCode){
						this.event.trigger("error:nommins", nomMinsErrCode);
					}					
					if(nomSecsErrCode){
						this.event.trigger("error:nomsecs", nomSecsErrCode);
					}
					if(bidMinsErrCode){
						this.event.trigger("error:bidmins", bidMinsErrCode);
					}					
					if(bidSecsErrCode){
						this.event.trigger("error:bidsecs", bidSecsErrCode);
					}
					if(resetMinsErrCode){
						this.event.trigger("error:resetmins", resetMinsErrCode);
					}					
					if(resetSecsErrCode){
						this.event.trigger("error:resetsecs", resetSecsErrCode);
					}
				}
			}
			
			if(!isError){
				var url = '/timers';
				var msg = {
						"isActive": this.draftTimer.get('isActive'), 
						"duration": durMille,
						"reset": true};
				
				if(isAuction) {
					url = '/timers/auction';
					msg = {
							"isActive": this.draftTimer.get('isActive'), 
							"duration": nomMille,
							"bidDuration": bidMille,
							"resetDuration": resetMille,
							"reset": true};
				}
				
				if(!this.isDemo){
					$.ajax({
						headers : {
							"Content-Type" : "application/json",
							"Accept" : "application/json"
						},
						url : '/draftapp/leagues/' 
							+ this.leagueInstance.get('leagueId') 
							+ '/league-instances/' 
							+ this.leagueInstance.get('id')
							+ url,
						type : 'POST',
						dataType : 'json',
						//accepts: 'application/json',
						//contentType: 'application/json',
						data : JSON.stringify(msg, null, 2),
						success: this.submitSuccess,
						error: this.submitError
					});
				}
			}
		},
		
		validateField: function(timerInput){
			var error = null;
			var numPattern = new RegExp("^[0-9]*$");
			
			//Make sure the hours field is within range and numeric
			if(!timerInput){
				error = "NULL";
			} else if(timerInput && !timerInput.length > 2 && !timerInput.length == 0){
				error = "LENGTH"; 
			} else if(!timerInput.match(numPattern)){
				error = "NUMERIC"; 
			}
			
			return error;
		},
		
		hideAll: function() {
			$(this.el).find(".timerDurBodyContentForm").hide();
			
			//Hide error messages
			$(this.formEl).find(".timerDurTimeInput1").removeClass("error");
			$(this.formEl).find(".timerDurTimeInput2").removeClass("error");
			$(this.formEl).find(".timerDurTimeInput3").removeClass("error");
			$(this.formEl).find(".timerDurTimeErrMsg1").hide();
			$(this.formEl).find(".timerDurTimeErrMsg2").hide();
			$(this.formEl).find(".timerDurTimeErrMsg3").hide();
			
			$(this.formEl).find(".nomTimerDurTimeInput1").removeClass("error");
			$(this.formEl).find(".nomTimerDurTimeInput2").removeClass("error");
			$(this.formEl).find(".bidTimerDurTimeInput1").removeClass("error");
			$(this.formEl).find(".bidTimerDurTimeInput2").removeClass("error");
			$(this.formEl).find(".resetTimerDurTimeInput1").removeClass("error");
			$(this.formEl).find(".resetTimerDurTimeInput2").removeClass("error");
			$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").hide();
			$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").hide();
			$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").hide();
			$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").hide();
			$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").hide();
			$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").hide();
		},
		
		form: function () {
			this.hideAll();
			$(this.formEl).show();
		},
		
		formReset: function() {
			this.hideAll();
			this.populateDurationInfo();
			$(this.formEl).show();
		},
		
		populateDurationInfo: function () {
			var duration = this.draftTimer.get('duration');
			
			var hours = Math.floor(duration/(1000 * 60 * 60));
			var mins = Math.floor((duration % (1000 * 60 * 60))/(1000 * 60)); //Take the remaining mins & seconds (after mod), and then get the floor of remaining mins
			var secs = Math.floor((duration % (1000 * 60))/1000); //Take the remaining secs (after mod), and then get the floor
			
			//Add a "0" if needed
			hours = ("0" + hours).slice(-2);
			mins = ("0" + mins).slice(-2);
			secs = ("0" + secs).slice(-2);
			
			$(this.el).find(".timerDurCurDisp").html(hours + ':' + mins + ':' + secs);
			
			if(this.leagueInstance.get('draftType') == 'AUCTION' && !this.durInitialized){
				var nomDuration = this.leagueInstance.get('timerDuration');
				var bidDuration = this.leagueInstance.get('bidDuration');
				var resetDuration = this.leagueInstance.get('resetDuration');
				
				var nomMins = Math.floor(nomDuration/60.0); 
				var nomSecs = nomDuration % 60; 
				var bidMins = Math.floor(bidDuration /60.0); 
				var bidSecs = bidDuration % 60; 
				var resetMins = Math.floor(resetDuration/60.0); 
				var resetSecs = resetDuration % 60; 
				
				nomMins = ("0" + nomMins).slice(-2);
				nomSecs = ("0" + nomSecs).slice(-2);
				bidMins = ("0" + bidMins).slice(-2);
				bidSecs = ("0" + bidSecs).slice(-2);
				resetMins = ("0" + resetMins).slice(-2);
				resetSecs = ("0" + resetSecs).slice(-2);
				
				$(this.formEl).find(".nomTimerDurTimeInput1").val(nomMins);
				$(this.formEl).find(".nomTimerDurTimeInput2").val(nomSecs);
				$(this.formEl).find(".bidTimerDurTimeInput1").val(bidMins);
				$(this.formEl).find(".bidTimerDurTimeInput2").val(bidSecs);
				$(this.formEl).find(".resetTimerDurTimeInput1").val(resetMins);
				$(this.formEl).find(".resetTimerDurTimeInput2").val(resetSecs);
			} else if(!this.durInitialized){
				$(this.formEl).find(".timerDurTimeInput1").val(hours);
				$(this.formEl).find(".timerDurTimeInput2").val(mins);
				$(this.formEl).find(".timerDurTimeInput3").val(secs);
			}
			
			this.durInitialized = true;
			
		},
		
		submitSuccess: function(data, status) {
			this.event.trigger("success");
		},
		
		submitError: function(data, status) {
			this.event.trigger("error");
		},
		
		errorHours : function (errorCode) {
			$(this.formEl).find(".timerDurTimeInput1").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".timerDurTimeErrMsg1").html("Hours field is empty");
					$(this.formEl).find(".timerDurTimeErrMsg1").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".timerDurTimeErrMsg1").html("Hours field must be 1 or 2 numbers");
					$(this.formEl).find(".timerDurTimeErrMsg1").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".timerDurTimeErrMsg1").html("Hours field may only contain numbers");
					$(this.formEl).find(".timerDurTimeErrMsg1").show();
					break;
				default : 
					$(this.formEl).find(".timerDurTimeErrMsg1").html("Hours field is invalid");
					$(this.formEl).find(".timerDurTimeErrMsg1").show();
			}
		},
		
		errorMins : function (errorCode) {
			$(this.formEl).find(".timerDurTimeInput2").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".timerDurTimeErrMsg2").html("Minutes field is empty");
					$(this.formEl).find(".timerDurTimeErrMsg2").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".timerDurTimeErrMsg2").html("Minutes field must be 1 or 2 numbers");
					$(this.formEl).find(".timerDurTimeErrMsg2").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".timerDurTimeErrMsg2").html("Minutes field may only contain numbers");
					$(this.formEl).find(".timerDurTimeErrMsg2").show();
					break;
				default : 
					$(this.formEl).find(".timerDurTimeErrMsg2").html("Minutes field is invalid");
					$(this.formEl).find(".timerDurTimeErrMsg2").show();
			}
		},
		
		errorSecs : function (errorCode) {
			$(this.formEl).find(".timerDurTimeInput3").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".timerDurTimeErrMsg3").html("Seconds field is empty");
					$(this.formEl).find(".timerDurTimeErrMsg3").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".timerDurTimeErrMsg3").html("Seconds field must be 1 or 2 numbers");
					$(this.formEl).find(".timerDurTimeErrMsg3").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".timerDurTimeErrMsg3").html("Seconds field may only contain numbers");
					$(this.formEl).find(".timerDurTimeErrMsg3").show();
					break;
				default : 
					$(this.formEl).find(".timerDurTimeErrMsg3").html("Seconds field is invalid");
					$(this.formEl).find(".timerDurTimeErrMsg3").show();
			}
		},
		
		errorNomMins : function (errorCode) {
			$(this.formEl).find(".nomTimerDurTimeInput1").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").html("Minutes field is empty");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").html("Minutes field must be 1 or 2 numbers");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").html("Minutes field may only contain numbers");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").show();
					break;
				default : 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").html("Minutes field is invalid");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom1").show();
			}
		},
		
		errorNomSecs : function (errorCode) {
			$(this.formEl).find(".nomTimerDurTimeInput2").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").html("Seconds field is empty");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").html("Seconds field must be 1 or 2 numbers");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").html("Seconds field may only contain numbers");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").show();
					break;
				default : 
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").html("Seconds field is invalid");
					$(this.formEl).find(".nomTimerDurTimeErrMsgNom2").show();
			}
		},
		
		errorBidMins : function (errorCode) {
			$(this.formEl).find(".bidTimerDurTimeInput1").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").html("Minutes field is empty");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").html("Minutes field must be 1 or 2 numbers");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").html("Minutes field may only contain numbers");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").show();
					break;
				default : 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").html("Minutes field is invalid");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst1").show();
			}
		},
		
		errorBidSecs : function (errorCode) {
			$(this.formEl).find(".bidTimerDurTimeInput2").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").html("Seconds field is empty");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").html("Seconds field must be 1 or 2 numbers");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").html("Seconds field may only contain numbers");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").show();
					break;
				default : 
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").html("Seconds field is invalid");
					$(this.formEl).find(".bidTimerDurTimeErrMsgFirst2").show();
			}
		},
		
		errorResetMins : function (errorCode) {
			$(this.formEl).find(".resetTimerDurTimeInput1").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").html("Minutes field is empty");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").html("Minutes field must be 1 or 2 numbers");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").html("Minutes field may only contain numbers");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").show();
					break;
				default : 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").html("Minutes field is invalid");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset1").show();
			}
		},
		
		errorResetSecs : function (errorCode) {
			$(this.formEl).find(".resetTimerDurTimeInput2").addClass("error");
			switch (errorCode){
				case "NULL": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").html("Seconds field is empty");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").show();
					break;
				case "LENGTH": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").html("Seconds field must be 1 or 2 numbers");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").show();
					break;
				case "NUMERIC": 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").html("Seconds field may only contain numbers");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").show();
					break;
				default : 
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").html("Seconds field is invalid");
					$(this.formEl).find(".resetTimerDurTimeErrMsgReset2").show();
			}
		},
		
		destroyView: function () {
			this.stopListening();
	    	this.undelegateEvents();
		}
	});

	var TimerDurMessageView = Backbone.View.extend({
		initialize: function(options) {
			this.event = options.event;
			
			this.hideAll();
			
			this.listenTo(this.event, 'default', this.hideAll);
			this.listenTo(this.event, 'saving', this.processing);
			this.listenTo(this.event, 'error', this.error);
			this.listenTo(this.event, 'success', this.success);
		},
		
		hideAll: function() {
			$(this.el).hide();
			$(this.el).find(".timerDurBodyMessageError").hide();
			$(this.el).find(".timerDurBodyMessageProcessing").hide();
			$(this.el).find(".timerDurBodyMessageSuccess").hide();
		},
		
		error: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find(".timerDurBodyMessageError").show();
		},
		
		success: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find(".timerDurBodyMessageSuccess").show();
			$(this.el).find(".timerDurBodyMessageSuccess").fadeOut(3000);
		},
		
		processing: function () {
			this.hideAll();
			$(this.el).show();
			$(this.el).find(".timerDurBodyMessageProcessing").show();
		},
		
		destroyView: function () {
			this.stopListening();
	    	this.undelegateEvents();
		}
	});

	var TimerDurView = Backbone.View.extend({
		initialize: function(options) {
			this.event = _.extend({}, Backbone.Events);
			this.draftTimer = options.draftTimer;
			this.leagueInstance = options.leagueInstance;
			this.draftStatusModel = options.draftStatusModel;
			
			this.message = new TimerDurMessageView({el: $(this.el).find(".timerDurBodyMessage"), event: this.event});
			this.content = new TimerDurContentView({
					el: $(this.el), 
					draftTimer: this.draftTimer,
					leagueInstance: options.leagueInstance,
					draftStatusModel: options.draftStatusModel,
					event: this.event});
			this.footer = new TimerDurFooterView({el: $(this.el), leagueInstance: options.leagueInstance, event: this.event});
		},
		
		render: function () {
			this.event.trigger("default");
			return this;
		},
		
		close: function () {
			this.message.destroyView();
			this.content.destroyView();
			this.footer.destroyView();
			
			this.stopListening();
	    	this.undelegateEvents();
		}
	});

	var TimerView = Backbone.View.extend({
		//el: $("#timerContainer"),
		
		initialize: function(options) {
			this.draftTimer = options.draftTimer;
			this.leagueInstance = options.leagueInstance;
			this.user = options.user;
			this.soundView = options.soundView;
			this.draftStatusModel = options.draftStatusModel;
			
			this.time = this.$el.find(".draftTimeLeft");
			this.playEl = this.$el.find(".timerControlsPlay");
			this.pauseEl = this.$el.find(".timerControlsPause");
			this.resetEl = this.$el.find(".timerControlsReset");
			this.changeEl = this.$el.find(".timerControlsChange");
			
			this.timerLabel = this.$el.find(".timerLabel");
			
			this.expireSoundPlayed = true;
			this.secondSoundPlayed = -1;
			
			this.listenTo(this.draftTimer, 'change', this.render);
			this.listenTo(this.user, 'change:userName', this.commishRender);
			
			_.bindAll(this, 'intervalUpdate');
			_.bindAll(this, 'setTimerDisplay');
			_.bindAll(this, 'playTimerSound');
			_.bindAll(this, 'playTimer');
			_.bindAll(this, 'pauseTimer');
			_.bindAll(this, 'resetTimer');
			//_.bindAll(this, 'openDurationPopup');
			//_.bindAll(this, 'closeDurationPopup');
			
			this.playEl.on('click', this.playTimer);
			this.pauseEl.on('click', this.pauseTimer);
			this.resetEl.on('click', this.resetTimer);
			//this.changeEl.on('click', this.openDurationPopup);
			
			//this.render();
			
			this.durationView =  new TimerDurView({
				el : this.$el.find(".timerDurContent"),
				draftTimer: this.draftTimer,
				leagueInstance: this.leagueInstance,
				draftStatusModel: this.draftStatusModel});
			
			this.firstRender = true;
			
			var rightNow = new Date();
			
			//Setup basic timer variables for later
			var timerDisableTime = this.leagueInstance.get('timerDisableTime');
			var timerEnableTime = this.leagueInstance.get('timerEnableTime');
			
			this.timerBreak = timerDisableTime != timerEnableTime;
			var timezoneOffset = 5; //Times are saved as CST so add 6 to convert from CDT to UTC
			
			this.timerDisableDate = new Date();
			var disableHours = Math.floor(timerDisableTime / 60.0) + timezoneOffset; // Round down
			if(disableHours > 23){
				disableHours = disableHours - 24;
			}
			this.timerDisableDate.setUTCHours(disableHours); 
			this.timerDisableDate.setUTCMinutes(timerDisableTime % 60);
			this.timerDisableDate.setUTCSeconds(0);
			this.timerDisableDate.setUTCMilliseconds(0);
			
			this.timerEnableDate = new Date();
			var enableHours = Math.floor(timerEnableTime / 60.0) + timezoneOffset; // Round down
			if(enableHours > 23){
				enableHours = enableHours - 24;
			}
			this.timerEnableDate.setUTCHours(enableHours); // Round down
			this.timerEnableDate.setUTCMinutes(timerEnableTime % 60);
			this.timerEnableDate.setUTCSeconds(0);
			this.timerEnableDate.setUTCMilliseconds(0);
		},
		
		render: function () {
			if(this.firstRender){
				this.durationView.render();
				this.commishRender();
				this.firstRender = false;
			}
			
			clearInterval(this.timedDispUpdate);
			
			if(!this.draftTimer){
				this.time.html('99:99');
				this.time.removeClass('expired');
				this.playEl.show();
				this.pauseEl.hide();
				
				this.time.addClass('paused');
				this.timerLabel.html('Timer - Paused');
			} else if(!this.draftTimer.get('isActive') && !this.draftTimer.get('pauseTimeRemaining')){
				//Timer doesn't exist on server so set default timer
				this.setTimerDisplay(this.draftTimer.get('duration'));
				
				this.playEl.show();
				this.pauseEl.hide();
				
				this.time.addClass('paused');
				this.timerLabel.html('Timer - Paused');
			} else if(!this.draftTimer.get('isActive')){
				this.setTimerDisplay(this.draftTimer.get('pauseTimeRemaining'));
				
				this.playEl.show();
				this.pauseEl.hide();
				
				this.time.addClass('paused');
				this.timerLabel.html('Timer - Paused');
				
				if(this.soundView){
					this.soundView.timerStop();
				}
			} else {
				this.intervalUpdate();
				
				//Since the seconds remaining are calculated through a mod, run this every 100ms instead of 1s to get a more accurate display
				//Otherwise it could be off by up to 999ms
				this.timedDispUpdate = window.setInterval((function(self) {         
			         		return function() {self.intervalUpdate();};
			     	})(this),100);
				
				this.playEl.hide();
				this.pauseEl.show();
				
				this.time.removeClass('paused');
				this.timerLabel.html('Timer');
				
				if(this.soundView){
					this.soundView.timerStart();
				}
			}
			
			return this;
		},
		
		commishRender: function () {
			var userName = this.user.get('userName');
			var isAssistant = this.leagueInstance.isAssistant(userName);
			
			if(isAssistant){
				this.$el.addClass('timerOwner');
				this.$el.find('[data-toggle=dropdown]').removeClass('disabled');
			} else {
				this.$el.removeClass('timerOwner');
				this.$el.find('[data-toggle=dropdown]').addClass('disabled');
			}
		},
		
		intervalUpdate: function(){
			var rightNow = new Date();
			
			//If both times are in the past, then show the future times
			if(this.timerDisableDate.getTime() < rightNow.getTime() && this.timerEnableDate.getTime() < rightNow.getTime()){
				this.timerDisableDate.setTime(this.timerDisableDate.getTime() + (24*60*60*1000));
				this.timerEnableDate.setTime(this.timerEnableDate.getTime() + (24*60*60*1000));
			}
			
			if(this.timerBreak && this.timerEnableDate.getTime() < this.timerDisableDate.getTime() && this.timerEnableDate.getTime() > rightNow.getTime()){
				//End time is before the start time, so subtract a day since end time hasn't happened yet
				this.timerDisableDate.setTime(this.timerDisableDate.getTime() - (24*60*60*1000));
			} else if(this.timerBreak && this.timerEnableDate.getTime() < this.timerDisableDate.getTime() && this.timerEnableDate.getTime() < rightNow.getTime()) {
				//End time is before the start time, so add a day since end time already happened
				this.timerEnableDate.setTime(this.timerEnableDate.getTime() + (24*60*60*1000));
			}
			
			var breakDuration = this.timerEnableDate.getTime() - this.timerDisableDate.getTime();
			
			//Set up initial duration value
			var timeRemaining = this.draftTimer.get('endTime') + this.draftTimer.get('serverTimeDiff') - rightNow.getTime();
			
			if(this.timerBreak && rightNow.getTime() < this.timerEnableDate.getTime() && rightNow.getTime() > this.timerDisableDate.getTime()){
				//We're in the middle of a break so adjust time remaining
				timeRemaining = timeRemaining - (this.timerEnableDate.getTime() - rightNow.getTime());
				this.time.addClass('paused');
				this.timerLabel.html('Timer - Break');
			} else if(
					this.timerBreak 
					&& rightNow.getTime() < this.timerEnableDate.getTime() 
					&& (this.draftTimer.get('endTime') + this.draftTimer.get('serverTimeDiff')) > this.timerDisableDate.getTime()){
				//Not in a break, but there is one coming up
				timeRemaining = timeRemaining - breakDuration;
				this.time.removeClass('paused');
				this.timerLabel.html('Timer');
			} else {
				this.time.removeClass('paused');
				this.timerLabel.html('Timer');
			}
			
			//if(this.draftStatusModel.get('auctionBidding') && timeRemaining > (this.leagueInstance.get('bidDuration')*1000)){
				//Make sure duration shown isn't higher then the set duration
			//	timeRemaining = (this.leagueInstance.get('bidDuration') * 1000);
			//} else if(!this.draftStatusModel.get('auctionBidding') && timeRemaining > (this.leagueInstance.get('timerDuration')*1000)){
			//	timeRemaining = (this.leagueInstance.get('timerDuration') * 1000);
			//}
			
			if(timeRemaining > this.draftTimer.get('duration')){
				//Make sure duration shown isn't higher then the set duration
				timeRemaining = this.draftTimer.get('duration');
			}
			
			this.setTimerDisplay(timeRemaining);
			
			if(this.soundView){
				this.playTimerSound(timeRemaining);
			}
			
			if(timeRemaining < 0){
				clearInterval(this.timedDispUpdate);
			}
		},
		
		setTimerDisplay: function (timeRemaining) {
			if(timeRemaining > 0){
				var hours = Math.floor(timeRemaining/(1000 * 60 * 60));
				var mins = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)); //Take the remaining mins & seconds (after mod), and then get the floor of remaining mins
				var secs = Math.floor((timeRemaining % (1000 * 60))/1000); //Take the remaining secs (after mod), and then get the floor
				
				//Add a "0" if needed
				hours = ("0" + hours).slice(-2);
				mins = ("0" + mins).slice(-2);
				secs = ("0" + secs).slice(-2);
				
				this.time.removeClass('expired');
				
				if(hours > 0) {
					this.time.html(hours + ':' + mins);
				} else {
					this.time.html(mins + ':' + secs);
				}
			} else {
				this.time.addClass('expired');
				this.time.html('00:00');
			}		
		},
		
		playTimerSound: function(timeRemaining) {
			if(timeRemaining > 0){
				this.expireSoundPlayed = false;
				var soundAlreadyPlayed = true;
				var secs = Math.floor(timeRemaining/1000); //Take the remaining secs (after mod), and then get the floor
				
				if(this.secondSoundPlayed != secs) {
					this.secondSoundPlayed = secs;
					soundAlreadyPlayed = false;
				}
				
				if(secs == 10 && !soundAlreadyPlayed){
					this.soundView.playTimerWarning();
				} else if(secs < 6 && secs > 0 &&  !soundAlreadyPlayed){
					this.soundView.playCountdown();
				}
			} else if(!this.expireSoundPlayed){
				this.expireSoundPlayed = true;
				
				if(!this.draftStatusModel.get('auctionBidding')){
					this.soundView.playTimerExp();
				}
			}
		},
		
		playTimer: function(event) {
			event.preventDefault();
			var msg = {
					"isActive": true, 
					"duration": this.draftTimer.get('duration'),
					"reset": false};
			
			if(!this.isDemo){
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/timers',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(msg, null, 2),
					success: function(data, status) {},
					error: function(data, status) {}
				});
			}
		},
		
		pauseTimer: function(event) {
			event.preventDefault();
			var msg = {
					isActive: false, 
					duration: this.draftTimer.get('duration'),
					"reset": false};
			
			if(!this.isDemo){
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/timers',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(msg, null, 2),
					success: function(data, status) {},
					error: function(data, status) {}
				});
			}
		},
		
		resetTimer: function(event) {
			event.preventDefault();
			var msg = {
					isActive: this.draftTimer.get('isActive'), 
					duration: this.draftTimer.get('duration'),
					"reset": true};
			
			if(!this.isDemo){
				$.ajax({
					headers : {
						"Content-Type" : "application/json",
						"Accept" : "application/json"
					},
					url : '/draftapp/leagues/' 
						+ this.leagueInstance.get('leagueId') 
						+ '/league-instances/' 
						+ this.leagueInstance.get('id')
						+ '/timers',
					type : 'POST',
					dataType : 'json',
					//accepts: 'application/json',
					//contentType: 'application/json',
					data : JSON.stringify(msg, null, 2),
					success: function(data, status) {},
					error: function(data, status) {}
				});
			}
		}
	});
	
	return TimerView;  
});